var ResponseHelper = function () {};

ResponseHelper.install = function (Vue, options) {
  let design = {//请柬设计图的尺寸
    width: 750
  };

  let maxView = {//PC浏览器里显示的最大尺寸
    width: 750
  };

  let win = {};//浏览器的窗口尺寸
  let view = {};

  window.onresize = (function(){
    let doc = window.document;
    win.width=doc.documentElement&&doc.documentElement.clientWidth || doc.body.clientWidth || window.innerWidth;
    win.height=doc.documentElement&&doc.documentElement.clientHeight || doc.body.clientHeight||window.innerHeight;
    //确定视图大小
    let e =navigator.userAgent;
    if(e.match(/iPhone|iPod/i) || e.indexOf("Android")>-1){
      //手机浏览器
      //显示为全屏
      view = win;

    }else{
      //PC
      let win_width = Math.min(win.width, maxView.width);

      view.width = win_width;

      let style = document.documentElement.style;
      style.width = win_width + 'px';
      style.marginLeft = style.marginRight = 'auto';
    }
    let remUnit = (view.width * 100 / design.width);
    document.documentElement.style.fontSize = remUnit + 'px';
    Vue.prototype.rem2px = function (rem) {
      return rem * remUnit;
    };

    return this;

  })();

  Vue.prototype.view = view;
  Vue.prototype.win = win;
  Vue.prototype.design = design;

};

export default ResponseHelper;



// WEBPACK FOOTER //
// ./src/plugin/ResponseHelper.js